export default __webpack_public_path__ + "static/media/clinic.6731c7c3.png";